import {AppState, initialAppState} from '@lib/store/appState';

export type RootState = {
  app: AppState;
};

export const rootState: RootState = {
  app: initialAppState,
};
